import type { FC } from "react";

import { SimplifiedPrizes as UISimplifiedPrizes } from "@jti/loyalty/components/SimplifiedPrizes";

import type { simplifiedPrizesInputs } from "./SimplifiedPrizes.builder";

type SimplifiedPrizesBuilderProps = BuilderComponentProps<typeof simplifiedPrizesInputs>;

export const SimplifiedPrizes: FC<SimplifiedPrizesBuilderProps> = (props) => {
  return <UISimplifiedPrizes {...props} />;
};
